/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  UPDATE_STATUS: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.payoutListPage.updateEventStatus',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'UPDATE_STATUS' },
      },
    },
    UPDATE_STATUS: {
      invoke: {
        id: 'updateStatus',
        src: 'updateStatus',
        onDone: {
          target: 'UPDATE_STATUS_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'UPDATE_STATUS_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    UPDATE_STATUS_SUCCESS: {
      on: {
        START: { target: 'UPDATE_STATUS' },
      },
    },
    UPDATE_STATUS_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
